import { CONTENT_GUTTER } from '@backrs_ui/grow-ui/src/components/PageShell/pageShell.layout';

import { Box, Divider, SxProps, Theme } from '@mui/material';

type ResizableDividerProps = Readonly<{
  onMouseDown: () => void;
}>;

export const ResizableDivider = ({ onMouseDown }: ResizableDividerProps) => {
  return (
    <Box sx={dividerWrapperSx} onMouseDown={onMouseDown}>
      <Divider orientation="vertical" flexItem sx={dividerSx} />
    </Box>
  );
};

const dividerWrapperSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  alignItems: 'stretch',
  cursor: 'col-resize',
  pl: backrs.spacing[CONTENT_GUTTER],
  // Stop the line where the chat panel ends instead of running to the row bottom.
  pb: backrs.spacing['spacing-xl'],
  '&:hover': {
    '& .MuiDivider-root': {
      boxShadow: `0 0 2px ${backrs.colors['Error/200']}, 0 0 4px ${backrs.colors['Error/200']}`,
    },
  },
});

const dividerSx: SxProps<Theme> = ({ backrs }) => ({
  backgroundColor: backrs.colors['Error/400'],
  width: '1px',
  pointerEvents: 'none',
  transition: 'box-shadow 0.2s ease-in-out',
});

export const LUBAV_PANEL_DEFAULT_WIDTH_PCT = 32;

export const LUBAV_PANEL_MIN_WIDTH_PX = 220;

export const leftPanelWrapperSx = (leftWidth: number): SxProps<Theme> => ({
  width: `${leftWidth}%`,
});

export const rightPanelWrapperSx = (leftWidth: number): SxProps<Theme> => ({
  width: `${100 - leftWidth}%`,
  minWidth: 0,
});
